import { createAction } from '@ngrx/store';

export namespace UserNavigationActions {
  enum UserNavigationActionTypes {
    GoToUserList = '[Router] Navigate to user list',
  }

  export const goToUserList = createAction(UserNavigationActionTypes.GoToUserList);
}
